<template>
  <div class="addMedical">
    <div class="outer-border">
      <div class="b-title title-border-bottom">添加自测用户</div>
      <div class="set-padding">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules1">
          <el-row>
            <el-col :span="8">
              <el-form-item label="医案编号：">
                <el-input size="small" v-model="form.id" placeholder="请输入医案编号" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联账号：">
                <el-input disabled size="small" v-model="form.userId" placeholder="请输入关联账号" maxlength="20"
                  show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名：" prop="name">
                <el-input size="small" maxlength="20" show-word-limit v-model="form.name"
                  placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="医案分类：">
                <el-select size="small" v-model="form.type" filterable placeholder="请选择">
                  <el-option v-for="item of YAList" :key="item.id" :value="item.value.toString()"
                    :label="item.lableTwo"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" prop="cards">
              <el-form-item label="身份证号：" prop="cards">
                <el-input size="small" v-model="form.cards" placeholder="请输入身份证号" @blur="cardFinish()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别：" prop="sex">
                <el-select size="small" disabled v-model="form.sex" placeholder="请选择" @change="onSelectedSex($event)">
                  <el-option label="男" value="男"></el-option>
                  <el-option label="女" value="女"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生日期：">
                <el-date-picker size="small" disabled v-model="form.birthDate" type="date" placeholder="自动生成"
                  value-format="yyyy-MM-dd" style="width:auto"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="年龄：">
                <el-input size="small" disabled v-model="form.age" placeholder="自动生成"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="民族：">
                <el-select size="small" v-model="form.nation" filterable placeholder="请选择">
                  <el-option v-for="item of nationList" :key="item.id" :value="item.value.toString()"
                    :label="item.lableTwo"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="婚姻状态：">
                <el-select size="small" v-model="form.maritalStatus" placeholder="请选择" clearable>
                  <el-option label="已婚" value="0"></el-option>
                  <el-option label="未婚" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性史：">
                <el-select size="small" v-model="form.sexHistory" placeholder="请选择">
                  <el-option label="有" value="0"></el-option>
                  <el-option label="无" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="地址：">
                <el-cascader size="small" :options="options" v-model="form.selectedOptions" @change="addressChange"
                  placeholder="请选择省/市/区/街道"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label>
                <el-input size="small" v-model="form.address" placeholder="请输入详细地址" maxlength="20"
                  show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="教育程度:">
                <el-select size="small" v-model="form.educational" placeholder="请选择" clearable>
                  <el-option v-for="item in educationLevelList" :key="item.value" :label="item.label"
                    :value="item.value.toString()"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职业：">
                <el-select size="small" v-model="form.job" placeholder="请选择" clearable>
                  <el-option v-for="item in occupationList" :key="item.value" :label="item.label"
                    :value="item.value.toString()"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身高：" class="shenti" prop="height">
                <el-row>
                  <el-col :span="12">
                    <el-input size="small" v-model="form.height" placeholder="身高">
                      <template slot="append">cm</template>
                    </el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input size="small" v-model="form.weight" placeholder="体重">
                      <template slot="append">Kg</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="体重：" class="shenti" prop="weight">
                <el-input size="small" v-model="form.weight" placeholder="体重">
                  <template slot="append">Kg</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="生育史：" v-if="womenSee">
                <el-radio-group v-model="form.sys" @change="shengyuChange">
                  <el-radio label="0">有</el-radio>
                  <el-radio label="1">无</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生育数量:" v-if="shengyuShow">
                <el-select size="small" v-model="form.childbearingHistory" placeholder="请选择">
                  <el-option label="1个" value="1"></el-option>
                  <el-option label="2个" value="2"></el-option>
                  <el-option label="3个" value="3"></el-option>
                  <el-option label="4个" value="4"></el-option>
                  <el-option label="多个" value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="是否孕妇：" v-if="womenSee">
                <el-radio-group v-model="form.isPregnant" @change="isPregnantChange">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="怀孕时间" v-if="pregnant">
                <el-date-picker v-model="form.pregnancyStartTime1" type="date" size="small" placeholder="选择日期"
                  value-format="timestamp" @change="getYunZhou" style="width:auto"
                  :picker-options="beginDate()"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="孕周" v-if="pregnant">
                <el-input v-model="form.pregnantWeek" disabled size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="dotted-line"></el-col>
          </el-row>
          <el-form-item label="个人史：" class="bg-label">
            <div v-for="(item, idx) in GRSList" :key="idx" style="float: left">
              <span :key="idx" class="yws" v-if="!item.custom">
                <el-checkbox :label="item.lableTwo" v-model="item.check"></el-checkbox>
                <el-date-picker size="small" class="inputIn marginl2" v-model="item.selectYears" type="year"
                  placeholder="请选择年份" value-format="yyyy" :picker-options="beginDate()"></el-date-picker>
              </span>
              <span :key="idx" class="yws" v-else>
                <el-checkbox label="其他" v-model="item.check"
                  @change="val => changeVal1(val, idx, 'GRSList')"></el-checkbox>
                <el-input size="small" v-model="item.lableTwo" placeholder="请输入病症" maxlength="20" show-word-limit
                  class="width130 marginl2"></el-input>
                <el-date-picker size="small" class="width120" v-model="item.selectYears" type="year" placeholder="请选择年份"
                  value-format="yyyy" :picker-options="beginDate()"></el-date-picker>
              </span>
              <i v-if="idx + 1 === GRSList.length" @click="jzgmsClick('GRSList')"
                class="el-icon-circle-plus-outline"></i>
              <i v-if="idx !== 0" class="el-icon-circle-plus11"></i>
            </div>
          </el-form-item>
          <el-row>
            <el-col :span="24" class="dotted-line"></el-col>
          </el-row>
          <el-form-item label="既往史：" class="bg-label">
            <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入既往史"
                v-model="form.previousHistory" >
              </el-input>
            <!-- <div v-for="(item, idx) in JWSList" :key="idx" style="float: left">
              <span :key="idx" class="yws" v-if="!item.custom">
                <el-checkbox :label="item.lableTwo" v-model="item.check"></el-checkbox>
                <el-date-picker size="small" class="dateSelect marginl2" v-model="item.startDate" type="month"
                  placeholder="请选择年份" value-format="yyyy-MM-dd" :picker-options="beginDate()"></el-date-picker>
              </span>
              <span :key="idx" class="yws" v-else>
                <el-checkbox label="其他" v-model="item.check"
                  @change="val => changeVal1(val, idx, 'JWSList')"></el-checkbox>
                <el-input size="small" v-model="item.lableTwo" placeholder="请输入病症" maxlength="20" show-word-limit
                  class="marginl2 width130"></el-input>
                <el-date-picker size="small" class="marginl2 dateSelect width120" v-model="item.startDate" type="month"
                  placeholder="请选择年份" value-format="yyyy-MM-dd" :picker-options="beginDate()"></el-date-picker>
              </span>
              <i v-if="idx + 1 === JWSList.length" @click="jzgmsClick('JWSList')"
                class="el-icon-circle-plus-outline"></i>
              <i v-if="idx !== 0" class="el-icon-circle-plus11"></i>
            </div> -->
          </el-form-item>
          <el-row>
            <el-col :span="24" class="dotted-line"></el-col>
          </el-row>
          <el-form-item label="家族史：" class="bg-label">
            <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入家族史"
                v-model="form.familyMedicalHistory" >
              </el-input>
            <!-- <div v-for="(item, idx) in JZSList" :key="idx" style="float: left">
              <span :key="idx" class="yws" v-if="!item.custom">
                <el-checkbox :label="item.lableTwo" v-model="item.check"></el-checkbox>
                <el-select size="small" v-model="item.familyMember" placeholder="请选择家庭关系" class="marginl2">
                  <el-option label="父系" value="父系"></el-option>
                  <el-option label="母系" value="母系"></el-option>
                </el-select>
              </span>
              <span :key="idx" class="yws" v-else>
                <el-checkbox label="其他" v-model="item.check"
                  @change="val => changeVal1(val, idx, 'JZSList')"></el-checkbox>
                <el-input size="small" v-model="item.lableTwo" placeholder="请输入病症" maxlength="20" show-word-limit
                  class="width130 marginl2"></el-input>
                <el-select size="small" v-model="item.familyMember" placeholder="请选择">
                  <el-option label="父系" value="父系"></el-option>
                  <el-option label="母系" value="母系"></el-option>
                </el-select>
              </span>
              <i v-if="idx + 1 === JZSList.length" @click="jzgmsClick('JZSList')"
                class="el-icon-circle-plus-outline"></i>
              <i v-if="idx !== 0" class="el-icon-circle-plus11"></i>
            </div> -->
          </el-form-item>
          <el-row>
            <el-col :span="24" class="dotted-line"></el-col>
          </el-row>
          <el-form-item label="药物过敏史：" class="bg-label">
            <div v-for="(item, idx) in YWGMSList" :key="idx" style="float: left">
              <span :key="idx" class="yws" v-if="!item.custom">
                <el-checkbox :label="item.lableTwo" v-model="item.check"></el-checkbox>
              </span>
              <span :key="idx" class="yws" v-else>
                <el-checkbox label="其他" v-model="item.check"
                  @change="val => changeVal1(val, idx, 'YWGMSList')"></el-checkbox>
                <el-input size="small" maxlength="20" show-word-limit v-model="item.lableTwo" placeholder="请输入过敏原"
                  class="width130 marginl2"></el-input>
              </span>
              <i v-if="idx + 1 === YWGMSList.length" @click="jzgmsClick('YWGMSList')"
                class="el-icon-circle-plus-outline"></i>
            </div>
          </el-form-item>
          <el-row class="text-center">
            <el-col :span="24">
              <el-button @click="onSubmit('form')" class="red-long-btn long-btn">提 交</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import "@/assets/style/addMedical.css"; //引入公共样式
import rules from "@/common/rules";
import { getBirthdayFromIdCard, getAgeFromBirthday } from "@/common/birthday";

export default {
  name: "addMedical",
  data() {
    return {
      rules1: {
        age: [
          {
            validator: rules.FormValidate.Form().validateNumber,
            trigger: "blur"
          }
        ],
        height: [
          {
            validator: rules.FormValidate.Form().validateNumber,
            trigger: "blur",
            message: "身高最多一位小数的数字"
          }
        ],
        weight: [
          {
            validator: rules.FormValidate.Form().validateNumber,
            trigger: "blur",
            message: "体重格式最多一位小数的数字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur"
          }
        ],
        // maritalStatus: [
        //     {
        //         required: true,
        //         message: "请选择婚姻状态",
        //         trigger: "change"
        //     }
        // ],

        // sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        // birthDate: [
        //     {
        //         required: true,
        //         message: "请选择出生日期",
        //         trigger: "change"
        //     }
        // ],
        cards: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "change"
          },
          {
            validator: rules.FormValidate.Form().ID,
            trigger: ["blur", "change"]
          }
        ]
      },
      GRSList2: [],
      form: {
        selectedOptions: [],
        id: "",
        userId: "",
        name: "",
        cards: "",
        birthDate: "",
        age: "",
        nation: "",
        maritalStatus: "",
        sexHistory: "",
        province: "",
        city: "",
        district: "",
        address: "",
        educational: "",
        job: "",
        weight: "",
        height: "",
        sys: "",
        childbearingHistory: "",
        isPregnant: "",
        pregnancyStartTime1: null,
        pregnancyStartTime: null,
        pregnantWeek: "",
        grs: null, // 个人史
        // jws: null, // 既往史
        //家族史
        familyMedicalHistory:'',
        //既往史
        previousHistory:'',
        // jzs: null, // 家族史
        ywgms: null, // 药物过敏史
      },
      options: regionData, //地区
      womenSee: false, //只有性别为女的才能看见
      shengyuShow: false, //生育史有的话，才显示生育数量
      pregnant: false //是孕妇，才能看见
    };
  },
  methods: {
    addressChange(arr) {
      // console.log(arr);
      // console.log(
      //     CodeToText[arr[0]],
      //     CodeToText[arr[1]],
      //     CodeToText[arr[2]]
      // );
      if (!arr) return false;
      if (CodeToText[arr[1]] == "市辖区") {
        this.form.province = CodeToText[arr[0]];
        this.form.city = CodeToText[arr[0]];
        this.form.district = CodeToText[arr[2]];
      } else {
        this.form.province = CodeToText[arr[0]];
        this.form.city = CodeToText[arr[1]];
        this.form.district = CodeToText[arr[2]];
      }
    },
    onSubmit(formName) {
      let that = this;
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        let url = "medicalCasesPc/saveMedicalCases";
        //怀孕时间
        if (!!that.form.pregnancyStartTime1) {
          that.form.pregnancyStartTime = that.getdate(
            that.form.pregnancyStartTime1
          );
        }
        let flag = true;
        let flag1 = true;
        let flag2 = true;
        let flag3 = true;
        let flag4 = true;

        // 个人史
        that.form.personageHistorys = [];
        for (const item of that.GRSList) {
          if (item.check) {
            if (!item.lableTwo || !item.selectYears) {
              flag = false;
              flag1 = false;
              break;
            }
            that.form.personageHistorys.push({
              personalHistory: item.lableTwo,
              years: that.yearsCal(item.selectYears)
            });
          }
        }
        // 既往史
        that.form.previousHistorys = [];
        for (const item of that.JWSList) {
          if (item.check) {
            if (!item.lableTwo || !item.startDate) {
              flag = false;
              flag2 = false;

              break;
            }
            that.form.previousHistorys.push({
              previousHistory: item.lableTwo,
              startDate: item.startDate
            });
          }
        }
        // 家族史
        that.form.familyHistory = [];
        for (const item of that.JZSList) {
          if (item.check) {
            if (!item.lableTwo || !item.familyMember) {
              flag = false;
              flag3 = false;

              break;
            }
            that.form.familyHistory.push({
              illness: item.lableTwo,
              familyMember: item.familyMember
            });
          }
        }
        // 药物过敏史
        that.form.medicineIrritabilityHistory = [];
        for (const item of that.YWGMSList) {
          if (item.check) {
            if (!item.lableTwo) {
              flag = false;
              flag4 = false;

              break;
            }
            that.form.medicineIrritabilityHistory.push({
              medicine: item.lableTwo
            });
          }
        }
        if (flag == false) {
          if (flag1 == false) {
            that.$message.error("请您将已经勾选的个人史信息填写完整，再提交");
          }
          if (flag2 == false) {
            that.$message.error("请您将已经勾选的既往史信息填写完整，再提交");
          }
          if (flag3 == false) {
            that.$message.error("请您将已经勾选的家族史信息填写完整，再提交");
          }
          if (flag4 == false) {
            that.$message.error(
              "请您将已经勾选的药物过敏史信息填写完整，再提交"
            );
          }
          return false;
        }
        that.form.ssqBmList = that.form.selectedOptions;
        console.log('that.form', that.form)
        that.$http
          .post(url, that.form)
          .then(res => {
            res = res.data;
            if (res.code == 200) {
              that.$message({
                message: "保存成功！",
                type: "success"
              });
              that.$router.go(-1);
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(() => {
          });
      });
    },
    // 四史其他的交互
    changeVal1(val, idx, targetItem) {
      if (idx === this[targetItem].length - 1 && val) {
        if (targetItem === "GRSList") {
          //个人史
          this.grs = val
        }
        if (targetItem === "JWSList") {
          //既往史
          this.jws = val
        }
        if (targetItem === "JZSList") {
          //家族史
          this.jzs = val
        }
        if (targetItem === "YWGMSList") {
          //药物过敏史
          this.ywgms = val
        }
      }
    },
    // 药物过敏史
    changeVal() {
    },
    jzgmsClick(val, idx, targetItem) {
      //  console.log('val', val);
      // if (idx === this[targetItem].length - 1 && val) {

      // } else {
      //   this[targetItem].splice(idx, 1);
      // }
      if (val === "GRSList") {
        //个人史
        let check = this.GRSList[this.GRSList.length - 1]
        if (check.check === true && check.selectYears && check.lableTwo) {
          this.GRSList.push({
            check: false,
            id: "",
            lableTwo: "",
            custom: true
          });
        }
      }
      if (val === "JWSList") {
        //既往史
        let check = this.JWSList[this.JWSList.length - 1]
        if (check.check === true && check.startDate && check.lableTwo) {
          this.JWSList.push({
            check: false,
            id: "",
            lableTwo: "",
            custom: true
          });
        }
      }
      if (val === "JZSList") {
        //家族史
        let check = this.JZSList[this.JZSList.length - 1]
        if (check.check === true && check.lableTwo && check.familyMember) {
          this.JZSList.push({
            check: false,
            id: "",
            lableTwo: "",
            custom: true
          });
        }
      }
      if (val === "YWGMSList") {
        //药物过敏史
        let check = this.YWGMSList[this.YWGMSList.length - 1]
        if (check.check === true && check.lableTwo) {
          this.YWGMSList.push({
            check: false,
            id: "",
            lableTwo: "",
            custom: true,
          });
        }
      }

    },
    //选择性别
    onSelectedSex(a) {
      let that = this;
      if (a == "女") {
        that.womenSee = true;
      } else {
        that.womenSee = false;
        that.shengyuShow = false;
        that.pregnant = false;
      }
    },
    //选择生育史
    shengyuChange(val) {
      let that = this;
      if (val == 0) {
        that.shengyuShow = true;
      } else {
        that.shengyuShow = false;
      }
    },
    //选择是否为孕妇
    isPregnantChange(val) {
      let that = this;
      if (val == 0) {
        that.pregnant = true;
      } else {
        that.pregnant = false;
      }
    },
    //身份证输入之后出生日期以及年龄的回显
    cardFinish() {
      this.form.birthDate = getBirthdayFromIdCard(this.form.cards);
      this.form.age = getAgeFromBirthday(this.form.birthDate);
      //将获取到的证件号码转换一下以便得到长度判断是一代还是二代
      let idcode = this.form.cards + ""; //累赘代码
      let newidcode = idcode.split("").map(Number); //累赘代码
      //其实直接取this.form.cards的length就行
      if (newidcode.length == 15) {
        //15位身份证号
        // 年龄计算
        let nowYear = new Date().getFullYear(); //获取当前年份
        let nowMonth = new Date().getMonth(); //获取当前月份
        let idYear = Number(this.form.cards.slice(6, 8)) + Number(1900); //获取身份证年份
        let idMonth = this.form.cards.slice(8, 9); //获取身份证月份
        if (nowMonth - idMonth >= 0) {
          //   this.jsonData.nlJson.val = nowYear - idYear; //等号左边为自有代码，是承接容器，可忽略
          //   this.PKform.age = String(nowYear - idYear); //等号左边为自有代码，是承接容器，可忽略
        } else {
          //   this.jsonData.nlJson.val = String(nowYear - idYear - 1); //等号左边为自有代码，是承接容器，可忽略
          //   this.PKform.age = String(nowYear - idYear - 1); //等号左边为自有代码，是承接容器，可忽略
        }
        //性别判断
        let sexCheck = this.form.cards.slice(14, 15);
        if (sexCheck % 2 == 0) {
          // this.PKform.xbdm = "0";
          this.form.sex = "女";
          this.womenSee = true;
          //   this.jsonData.xfrxbJson.val = "0";
        } else {
          // this.PKform.xbdm = "1";
          this.form.sex = "男";
          this.womenSee = false;
          this.shengyuShow = false;
          this.pregnant = false;
          //   this.jsonData.xfrxbJson.val = "1";
        }
      } else if (newidcode.length == 18) {
        //18位身份证号
        // 年龄计算
        let nowYear = new Date().getFullYear(); //获取当前年份
        let nowMonth = new Date().getMonth(); //获取当前月份
        let idYear = this.form.cards.slice(6, 10); //获取身份证年份
        let idMonth = this.form.cards.slice(10, 11); //获取身份证月份
        if (nowMonth - idMonth >= 0) {
          //   this.jsonData.nlJson.val = nowYear - idYear;
          //   this.PKform.age = String(nowYear - idYear);
        } else {
          //   this.jsonData.nlJson.val = String(nowYear - idYear - 1);
          //   this.PKform.age = String(nowYear - idYear - 1);
        }
        //性别判断
        let sexCheck = this.form.cards.slice(16, 17);
        if (sexCheck % 2 == 0) {
          // this.PKform.xbdm = "0";
          this.form.sex = "女";
          this.womenSee = true;
          //   this.jsonData.xfrxbJson.val = "0";
        } else {
          // this.PKform.xbdm = "1";
          this.form.sex = "男";
          this.womenSee = false;
          this.shengyuShow = false;
          this.pregnant = false;
          //   this.jsonData.xfrxbJson.val = "1";
        }
      }
    },
    //根据怀孕起始时间得到孕周
    getYunZhou(val) {
      let that = this;
      if (!val) {
        that.form.pregnantWeek = "";
        return false;
      }
      let timestamp2 = new Date().valueOf();
      that.form.pregnantWeek = parseInt((timestamp2 - val) / 604800000);
      that.$delete(that.form, "pregnantWeek");
      that.$set(
        that.form,
        "pregnantWeek",
        parseInt((timestamp2 - val) / 604800000)
      );
    },
    // 去重方法
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length;) {
          if (arr[i].lableTwo === arr[j].lableTwo) {
            arr.splice(j, 1)
          } else {
            j++
          }
        }
      }
      return arr
    },
    //获取医案详情
    infoDisplay(id) {
      let that = this;
      let params = {
        id: id
      };
      let url = "medicalCasesPc/getYaById";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form = res.data;
            // 个人史回显
            // this.GRSList = [];
            this.GRSList2 = [];
            for (const item of res.data.personageHistorys) {
              that.GRSList2.push({
                check: true,
                id: item.id,
                lableTwo: item.personalHistory,
                selectYears: String(that.yearsCal(item.years))
              });
            }
            that.GRSList2.push({
              check: false,
              id: "",
              lableTwo: "",
              custom: true
            });
            let temporaryArry = []
            let newArr = that.GRSList2.concat(that.GRSList)
            let currentIdx = newArr.findIndex(v => v.lableTwo == "");
            temporaryArry.push(newArr[currentIdx]);
            newArr.splice(currentIdx, 1)
            newArr = newArr.concat(temporaryArry);
            that.GRSList = that.unique(newArr)
            // 既往史回显
            // this.JWSList = [];
            this.JWSList2 = [];
            for (const item of res.data.previousHistorys) {
              that.JWSList2.push({
                check: true,
                id: item.id,
                lableTwo: item.previousHistory,
                startDate: item.startDate
              });
            }
            this.JWSList2.push({
              check: false,
              id: "",
              lableTwo: "",
              custom: true
            });
            let JWSList2Arr = []
            let JWSNewArr = that.JWSList2.concat(that.JWSList)
            let JWScurrentIdx = JWSNewArr.findIndex(v => v.lableTwo == "");
            JWSList2Arr.push(JWSNewArr[JWScurrentIdx]);
            JWSNewArr.splice(JWScurrentIdx, 1)
            JWSNewArr = JWSNewArr.concat(JWSList2Arr);
            that.JWSList = that.unique(JWSNewArr)
            // 家族史回显
            // this.JZSList = [];
            this.JZSList2 = [];
            for (const item of res.data.familyHistory) {
              that.JZSList2.push({
                check: true,
                id: item.id,
                lableTwo: item.illness,
                familyMember: item.familyMember
              });
            }
            this.JZSList2.push({
              check: false,
              id: "",
              lableTwo: "",
              custom: true
            });
            let JZSList2Arr = []
            let JZSNewArr = that.JZSList2.concat(that.JZSList)
            let JZScurrentIdx = JZSNewArr.findIndex(v => v.lableTwo == "");
            JWSList2Arr.push(JZSNewArr[JZScurrentIdx]);
            JZSNewArr.splice(JZScurrentIdx, 1)
            JZSNewArr = JZSNewArr.concat(JZSList2Arr);
            that.JZSList = that.unique(JZSNewArr)
            // 药物过敏史回显
            // this.YWGMSList = [];
            this.YWGMSList2 = [];
            for (const item of res.data.medicineIrritabilityHistory) {
              that.YWGMSList2.push({
                check: true,
                id: item.id,
                lableTwo: item.medicine
              });
            }
            this.YWGMSList2.push({
              check: false,
              id: "",
              lableTwo: "",
              custom: true
            });
            let YWGMSList2 = []
            let YWGMSNewArr = that.YWGMSList2.concat(that.YWGMSList)
            let YWGMScurrentIdx = YWGMSNewArr.findIndex(v => v.lableTwo == "");
            JWSList2Arr.push(YWGMSNewArr[YWGMScurrentIdx]);
            YWGMSNewArr.splice(YWGMScurrentIdx, 1)
            YWGMSNewArr = YWGMSNewArr.concat(YWGMSList2);
            that.YWGMSList = that.unique(YWGMSNewArr)
            if (res.data.sex == "女") {
              that.womenSee = true;
            }
            if (res.data.childbearingHistory) {
              that.shengyuShow = true;
              that.form.sys = "0";
            }
            // 根据怀孕时间计算孕周
            if (res.data.pregnancyStartTime) {
              that.pregnant = true;
              that.form.pregnancyStartTime1 = that.changeChuo(
                res.data.pregnancyStartTime
              );
              let timestamp2 = new Date().valueOf();
              that.form.pregnantWeek = parseInt(
                (timestamp2 - that.form.pregnancyStartTime1) / 604800000
              );
            }
            // 省市区回显
            if (res.data.ssqBmStr) {
              let aaa = res.data.ssqBmStr.split(",");
              that.form.selectedOptions = [aaa[0], aaa[1], aaa[2]];
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    }
  },
  created() {
    let that = this;
    that.dataDictionary("GRS");
    that.dataDictionary("JZS");
    that.dataDictionary("JWS");
    that.dataDictionary("YWGMS");
    that.dataDictionary("JYCD");
    that.dataDictionary("ZY");
    that.dataDictionary("MZ");
    that.dataDictionary("YALX");
    // 关联账号
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.form.userId = this.userInfo.id;
    }
    if (!!that.$route.query.id) {
      //编辑
      that.form.id = that.$route.query.id;
      that.infoDisplay(that.$route.query.id);
    } else {
      //新增
      that.getNumber("YA").then(res => {
        that.form.id = res;
      });
    }
  }
};
</script>

<style>
.addMedical .el-input-group__append {
  padding: 0px 2px !important;
}

.shenti .el-form-item__content .el-input-group {
  vertical-align: middle;
}

.iconOut {}
</style>



// WEBPACK FOOTER //
// src/components/JW/addMedical.vue